module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12 px-0"
  }, _vm._l((_vm.filesList), function(file, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex col-sm-12 mb-2"
    }, [_c('div', {
      staticClass: "col-9 px-0 styleFileName"
    }, [_c('u', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(file)
        }
      }
    }, [_vm._v(_vm._s(file.Name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 px-0 text-right file-option-button"
    }, [(_vm.canDelete) ? _c('span', {
      staticClass: "btnDelete",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(_vm.$t('common.rm_label')))])]) : (_vm.canReplace) ? _c('label', {
      staticClass: "LMSGcolor btnAdd",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "for": 'file_reuploads-' + _vm.id
      }
    }, [_vm._v(_vm._s(_vm.$t('iframe_page.replace')))]) : _vm._e()])])
  }), 0), _vm._v(" "), (_vm.canAdd) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "float-right btnAdd",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": 'file_uploads-' + _vm.id
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.$t('common.add_label')))])])]) : _vm._e(), _vm._v(" "), _c('input', {
    key: 'add' + _vm.fileInputKey,
    ref: "file",
    staticClass: "d-none",
    attrs: {
      "id": 'file_uploads-' + _vm.id,
      "type": "file",
      "accept": ".jpeg,.jpg,.png,.pdf",
      "multiple": _vm.multiple
    },
    on: {
      "change": function($event) {
        return _vm.addFileToList()
      }
    }
  }), _vm._v(" "), _c('input', {
    key: 'replace' + _vm.fileInputKey,
    ref: "file_re",
    staticClass: "d-none",
    attrs: {
      "id": 'file_reuploads-' + _vm.id,
      "type": "file",
      "accept": ".jpeg,.jpg,.png,.pdf",
      "multiple": _vm.multiple
    },
    on: {
      "change": function($event) {
        return _vm.changeFileInList()
      }
    }
  }), _vm._v(" "), (_vm.hasError) ? _c('div', {
    staticClass: "col-sm-12 error-validate-msg text-justify"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21aa11d9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21aa11d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/components/multipleDocumentsUpload.vue
// module id = 2361
// module chunks = 2